import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services';

export const ADD_TO_PURCHASE = 'ADD_TO_PURCHASE';
export const REMOVE_FROM_PURCHASE = 'REMOVE_FROM_PURCHASE';
export const UPDATE_PURCHASE = 'UPDATE_PURCHASE';
export const CHANGE_VIEW = 'CHANGE_VIEW';
export const RESET_VIEW = 'RESET_VIEW';
export const SET_USER_INFO = 'SET_USER_INFO';
export const CHECK_EMAIL = 'CHECK_EMAIL';
export const GET_ALL_DONATIONS = 'GET_ALL_DONATIONS';
export const REMOVE_PURCHASE_ITEM = 'REMOVE_PURCHASE_ITEM';
export const GET_ALL_TRANSACTIONS = 'GET_ALL_TRANSACTIONS';
export const GET_TRANSACTION_DETAILS = 'GET_TRANSACTION_DETAILS';
export const UPDATE_COST_ACTION = 'UPDATE_COST_ACTION';
export const PURCHASE_LOADING = 'PURCHASE_LOADING';
export const SET_ALERT = 'SET_ALERT';

const successColor = 'success';
const errorColor = 'danger';
const warningColor = 'warning';

export const GET_DONATION_TYPES = 'GET_DONATION_TYPES';

export function addToPurchase(purchase) {
    return function (dispatch) {
        dispatch({
            type: ADD_TO_PURCHASE,
            payload: purchase
        });
    };
}

export function removeFromPurchase(purchase) {
    return function (dispatch) {
        dispatch({
            type: REMOVE_FROM_PURCHASE,
            payload: purchase
        });
    };
}

export function updatePurchase(purchase) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_PURCHASE,
            payload: purchase
        });
    };
}

export function changeView(purchase) {
    return function (dispatch) {
        dispatch({
            type: CHANGE_VIEW,
            payload: purchase
        });
    };
}

export function resetView() {
    return function (dispatch) {
        dispatch(loader(true));
        var url = `${ROOT_API_URL}/ManageTransaction/GetTransactions`;
        const options = { method: 'GET', headers: auth.authHeader() };
        axios
        .get(url, options)
        .then((response) => {
            dispatch({
                type: RESET_VIEW,
                payload: response.data
            });
            dispatch(loader(false));
        })
        .catch((error) => {
            var err = "Network Connection Error";
            dispatch(loader(false));
            dispatch(toastr(true, err, errorColor));
        });
    };
}

export function setUserInfo(user) {
    return function (dispatch) {
        dispatch({
            type: SET_USER_INFO,
            payload: user
        });
    };
}

export function checkEmailCall(email) {
    return function (dispatch) {
        dispatch({
            type: PURCHASE_LOADING,
            payload: true
        });
        if (email) {
            const options = { method: 'GET', headers: auth.authHeader() };
            // axios.get(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail?email=${email}`, options)
            axios.post(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail`,
                {
                    email: email
                },
                {
                    headers: auth.authHeader()
                }
            )
                .then((response) => {
                    if (response.data.issuccess) {
                        dispatch({
                            type: PURCHASE_LOADING,
                            payload: false
                        })
                        dispatch({
                            type: SET_USER_INFO,
                            payload: response.data.userInfo
                        })
                        dispatch({
                            type: SET_ALERT,
                            visible: true,
                            message: "User Found",
                            color: successColor
                        })
                        setTimeout(() => {
                            dispatch({
                                type: SET_ALERT,
                                visible: false,
                                message: ""
                            })
                        }, 5000)
                    } else {
                        dispatch({
                            type: PURCHASE_LOADING,
                            payload: false
                        })
                        dispatch({
                            type: SET_ALERT,
                            visible: true,
                            message: response.data.message,
                            color: errorColor
                        })
                        setTimeout(() => {
                            dispatch({
                                type: SET_ALERT,
                                visible: false,
                                message: ""
                            })
                        }, 5000)

                    }
                })
                .catch((response) => {
                    console.log(response);
                    dispatch({
                        type: PURCHASE_LOADING,
                        payload: false
                    })
                    dispatch({
                        type: SET_ALERT,
                        visible: true,
                        message: response.message,
                        color: errorColor
                    })
                });
        } else {
            dispatch({
                type: PURCHASE_LOADING,
                payload: false
            })
        }
    }
}

export function getDonationTypes() {
    return function (dispatch) {
        const options = { method: 'GET', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/GetDonationTypes`, options)
            .then((response) => {
                dispatch({
                    type: GET_DONATION_TYPES,
                    payload: response.data
                })
            })
            .catch((response) => {
                console.log(response);
            });
    }
}

export function fetchAllDonations() {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/ManageTransaction/GetDonations`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_ALL_DONATIONS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}


export function removePurchaseItem(index) {
    return function (dispatch) {
        dispatch({
            type: REMOVE_PURCHASE_ITEM,
            payload: index
        });
    };
}

export function getAllTransactions() {
    return function (dispatch) {
        dispatch(loader(true));
        var url = `${ROOT_API_URL}/ManageTransaction/GetTransactions`;
        const options = { method: 'GET', headers: auth.authHeader() };
        axios
            .get(url, options)
            .then((response) => {
                dispatch({
                    type: GET_ALL_TRANSACTIONS,
                    payload: response.data
                });
                dispatch(loader(false));
            })
            .catch((error) => {
                var err = "Network Connection Error";
                dispatch(loader(false));
                dispatch(toastr(true, err, errorColor));
            });
    };
}
export function getTransactionDetails(transactionId) {
    return function (dispatch) {
        dispatch(loader(true));
    var url = `${ROOT_API_URL}/ManageTransaction/GetTransactionDetails?transactionId=${transactionId}`;
        const options = { method: 'GET', headers: auth.authHeader() };
        axios
            .get(url, options)
            .then((response) => {
                dispatch({
                    type: GET_TRANSACTION_DETAILS,
                    payload: response.data
                });
                dispatch(loader(false));
            })
            .catch((error) => {
                var err = "Network Connection Error";
                dispatch(loader(false));
                dispatch(toastr(true, err, errorColor));
            });
    };
}



export function updateCostAction(state) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_COST_ACTION,
            payload: state
        });
    };
}

export function setAlert(visible, message, color) {
    return function (dispatch) {
        dispatch({
            type: SET_ALERT,
            visible: visible,
            message: message,
            color: color
        })
    }
}
